import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectCompanyIndex, selectHasAccessToken } from '../../redux/selector/system'

const RequireCompanyRegistration = () => {
	const hasAccessToken = useSelector(selectHasAccessToken)
	const companyIndex = useSelector(selectCompanyIndex)
	const navigate = useNavigate()

	useEffect(() => {
		if (!companyIndex && hasAccessToken) {
			navigate('/registration/company')
		}
	}, [companyIndex, hasAccessToken, navigate])

	return null
}

RequireCompanyRegistration.displayName = 'RequireCompanyRegistration'
export default RequireCompanyRegistration
